
<style scoped>
.diglog_h {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  padding: 24px;
  border-bottom: 1px solid #cfd4e8;
  color: #1a1a1a;
}
.diglog_icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.diglog_operation {
  margin: 30px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.admin-attendance-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 20px;
}

.admin-attendance-container .admin-attendance-item{
  width: 100%;
  border: 0.0625rem solid rgba(207, 212, 232, 0.5);
  height: 30rem;
  padding: 10px;
  overflow-y: auto;
  position: relative;
}
.admin-attendance-container .admin-attendance-item:first-child{
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.admin-attendance-container .admin-attendance-item:last-child{
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.admin-attendance-container .admin-attendance-item:not(:first-child){
  border-left: none;
}
.admin-attendance-container .admin-attendance-item .ai-tital{
  background: #ededed;
  text-align: center;
  padding: 5px;
  position: absolute;
  top:0;
  left: 0;
  right: 0;
}
.admin-attendance-container .admin-attendance-item .attendance-user-content{
  height: 26.5rem;
  overflow-y: auto;
}
.admin-attendance-container .admin-attendance-item .attendance-user-select{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  margin-top: 18px;
}
.admin-attendance-container .admin-attendance-item .attendance-user-unselect{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  margin-top: 18px;
}
.admin-attendance-container .admin-attendance-item .attendance-user-unselect .clear-all{
  cursor: pointer;
}
.custom-tree-node{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 5px;
  padding: 10px;
}
.custom-tree-node .depa_left_icon{
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background: #cbe7ff;
  margin-right: 0.625rem;;
}
.custom-tree-node .depa_left_icon img{
  width: 16px;
  height: 16px;
}
</style>
<style>
.attendance-dept-tree .el-tree-node__content{
  padding-top: 5px;
  padding-bottom: 5px;
  height: 2.5rem;
}
</style>

<template>
  <el-dialog
      title=""
      :visible.sync="visible"
      :close-on-click-modal="false"
      :show-close="false"
      width="60%"
  >
    <div class="diglog_h">
      <div>部门考勤通知配置</div>
      <img
          src="@/assets/structure/close.png"
          class="diglog_icon"
          @click="visible = false"
      />
    </div>
    <div class="admin-attendance-container">
      <div class="admin-attendance-item">
        <el-input placeholder="请输入内容" v-model="queryForm.name" clearable class="input-with-select">
          <el-select v-model="queryForm.type" slot="prepend" placeholder="请选择" style="width: 80px;">
            <el-option label="部门" :value="1"></el-option>
            <el-option label="人员" :value="2"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="selectUserList"></el-button>
        </el-input>
        <div style="height: 26rem; overflow-y: auto;padding: 5px;">
          <el-tree :data="deptData"
                   ref="tree"
                   class="attendance-dept-tree"
                   :props="defaultProps"
                   node-key="id"
                   :current-node-key="queryForm.deptId"
                   :highlight-current="true"
                   default-expand-all
                   :filter-node-method="filterNode"
                   @node-click="handleNodeClick">

            <div class="custom-tree-node" slot-scope="{ node, data }">
                <div style="display: flex;justify-content: start;align-items: center">
                  <div class="depa_left_icon">
                    <img src="@/assets/device.png" />
                  </div>
                  <span>{{ node.label }}</span>
                </div>
            </div>
          </el-tree>
        </div>
      </div>
      <div class="admin-attendance-item">
        <div class="ai-tital">未选择人员</div>
        <div class="attendance-user-select">
          <el-checkbox v-model="checkAll" >全选</el-checkbox>
          <div>已选：{{ waitPeopleList.filter(wp => completePeopleList.map(cp => cp.id).includes(wp.id)).length || 0 }}</div>
        </div>
        <div class="attendance-user-content">
          <el-checkbox-group v-model="completePeopleList">
            <virtual-list style="height: 25.5rem; overflow-y: auto;margin-top: 10px;"
                          :data-key="'id'"
                          :data-sources="waitPeopleList"
                          :data-component="memberUnselectedItemComponent"/>
          </el-checkbox-group>
        </div>
      </div>
      <div class="admin-attendance-item">
        <div class="ai-tital">已选择人员</div>
        <div class="attendance-user-unselect">
          <div class="clear-all" @click="clearAll">清除全部</div>
          <div>已选：{{ completePeopleList.length || 0 }}</div>
        </div>
        <div class="attendance-user-content">
          <virtual-list style="height: 25.5rem; overflow-y: auto;margin-top: 10px;"
                        :data-key="'id'"
                        :data-sources="completePeopleList"
                        :data-component="memberSelectedItemComponent"
                        :extra-props="{deleteSelect}"
          />
        </div>
      </div>
    </div>
    <div class="diglog_operation">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确认</el-button>
    </div>
  </el-dialog>
</template>


<script>
import MemberUnselectedItem from "@/views/account/setting/components/MemberUnselectedItem.vue";
import MemberSelectedItem from "@/views/account/setting/components/MemberSelectedItem.vue";
import http from "@/utils/http";
import {MessagePushDeptApi} from '@/api/server/messagePushDept';

export default {
  components: {},
  data() {
    return {
      visible: false,
      memberUnselectedItemComponent: MemberUnselectedItem,
      memberSelectedItemComponent: MemberSelectedItem,
      completePeopleList: [],
      waitPeopleList: [],
      queryForm: {
        type: 1,
        name: '',
        deptId: null
      },
      deptData: [],
      defaultProps: {
        children: 'subDepartment',
        label: 'name'
      },
      checkAll: false,
      submitLoading: false,
      ruleForm: {
        deptId: null
      }
    };
  },
  watch:{
    'queryForm.name': {
      handler: function (val, oldval) {
        if(this.queryForm.type == 1){
          this.$refs.tree.filter(val);
        }else{
          this.queryForm.deptId = null;
        }
      },
      deep: true,
    },
    completePeopleList: {
      handler: function (newValue, oldVal){
        if (this.waitPeopleList.length > 0) {
          var filteredArr = this.waitPeopleList;
          var isrepeat = this.hasDuplicates(newValue);
          if (isrepeat) {
            var arr = this.removeDuplicates(newValue);
            this.completePeopleList = arr;
          }
        }
      },
      deep: true
    },
    waitPeopleList: {
      handler(newValue, oldValue) {
        this.completePeopleList.map((item) => {
          var index = newValue.findIndex((citem) => item.id == citem.id);
          if (index > -1) {
            this.$set(newValue[index], "checked", true);
          }
        });
      },
      deep: true
    },
    checkAll: {
      handler: function (newVal, oldVal) {
        if(newVal){
          this.waitPeopleList.forEach(wp => {
            this.completePeopleList.push(wp);
          });
        }else{
           this.completePeopleList = this.completePeopleList.filter(cp => {
             return !this.waitPeopleList.map(wpl => wpl.id).includes(cp.id);
           })
        }
      },
      deep: true
    }
  },
  created() {

  },
  mounted() {

  },
  computed: {
  },
  methods: {
     async show(deptId){
       this.ruleForm.deptId = deptId;
       await this.getMessagePushDeptList();
       this.selectDeptList();
       this.visible = true;
    },
    selectDeptList(){
      http.get('/server/umsDepartment/list').then(response => {
        let {code, data} = response;
        if(code == 200){
          this.deptData = this.convertToNestedStructure(data);
          this.queryForm.deptId = this.deptData[0]?.id;
          this.selectUserList();
        }
      });

    },
    // 判断数组是否有重复
    hasDuplicates(array) {
      const set = new Set();
      for (let item of array) {
        if (set.has(item.id)) {
          return true; // 如果集合中已经存在该元素，则说明有重复
        }
        set.add(item.id); // 否则将元素添加到集合中
      }
      return false; // 遍历完数组后仍未发现重复项
    },
    // 数组去重
    removeDuplicates(array) {
      // 使用 Map 来去重，Map 的键是 id，值是对象本身
      const map = new Map();

      for (let item of array) {
        map.set(item.id, item); // 如果 id 已经存在，则会覆盖
      }

      // 将 Map 的值转换回数组
      return Array.from(map.values());
    },
    convertToNestedStructure(arr) {
      // 创建一个映射，用于快速查找具有特定id的对象
      const idMap = new Map(arr.map((item) => [item.id, item]));
      // 创建一个新数组来存储转换后的嵌套结构
      const nestedArr = [];
      // 遍历原始数组
      arr.forEach((item) => {
        // 如果该项有父元素，则将其添加到父元素的subDepartment数组中
        if (item.parent) {
          const parent = idMap.get(item.parent);
          if (parent) {
            if (!parent.subDepartment) {
              parent.subDepartment = [];
            }
            item.parentDepament = parent.name;
            parent.subDepartment.push(item);
          }
        } else {
          // 如果没有父元素，则添加到新数组的根级别
          nestedArr.push(item);
        }
      });
      // 返回转换后的嵌套数组
      return nestedArr;
    },
    selectUserList(){
      const query = {likeString: this.queryForm.name, deptId: this.queryForm.deptId};
      http.get(`/server/umsUser/queryUmsUserSimpleList`, query).then(response => {
        const {code,data} = response;
        if(code == 200){
          this.waitPeopleList = data.map(d => {
            // d.checked = true;
            d.checked = false;
            return d;
          });
        }
      });

    },
    filterNode(value, data) {
      if (!value) return true;
      return data?.name?.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      if(this.queryForm.deptId == data.id){
        return;
      }
      this.queryForm.deptId = data.id;
      this.selectUserList();
    },
    // 删除选中的人员
    deleteSelect(index) {
      this.completePeopleList.splice(index, 1);
    },
    handleSubmit(){
      this.submitLoading = true;
      const data = {
        deptId: this.ruleForm.deptId,
        receiverList: this.completePeopleList.map(cpl => cpl.id)
      }
      if(this.completePeopleList.length == 0){
        this.$message.error('请选择人员');
        return;
      }
      MessagePushDeptApi.addMessagePushDept(data).then(response => {
        const {code,data} = response;
        if(code == 200){
          this.$message.success('保存成功');
          this.$emit('success');
          this.visible = false;
        }else {
          this.$message.error(response.message || '保存失败');
        }
      }).finally(() => {
        this.submitLoading = false;
      })
    },
    clearAll(){
      this.completePeopleList = [];
    },
    getMessagePushDeptList(){
      MessagePushDeptApi.getMessagePushDeptListByCurrentCompany({deptId: this.ruleForm.deptId}).then(response => {
        const {code,data} = response;
        if(code == 200){
          this.completePeopleList = data;
        }
      })
    },
  }
};
</script>